import classNames from "classnames";
import { VarianButtonEnum } from "../../enum/Button/variantButton.model";
import { Button } from "../Button/Button";
import { Typography } from "../typography";
import { Links, Props } from "./types";
import DataContainer from "../../services/DataContainer";
import { DisclaimerTexts } from "../../enum/enums";

export const DisclaimerSection = ({
  links,
  positionOfLinks,
  positionOfContent,
  positionOfTitle,
  isSummary,
  isInfoModal,
}: Props) => {
  return (
    <div
      className={classNames(
        "w-full flex flex-col justify-center md:py-7 py-14 md:px-0 text-secondary", //changed md:py-10 to md:py-7
        { 
          "gap-4 !py-4": isInfoModal,
          "px-12": !isInfoModal,
          "items-center": !isSummary && !isInfoModal, 
        }
      )}
    >
      <div
        className={classNames("w-full text-xl", {
          "lg:text-left text-center": positionOfTitle === "left" && !isInfoModal,
          "text-left": positionOfTitle === "left" && isInfoModal,
          "text-right": positionOfTitle === "right",
          "text-center": positionOfTitle === "center",
          "text-black !text-2xl font-bold px-6": isInfoModal,
          "md:w-2/4": !isSummary,
        })}
      >
        <Typography tag="h4">
          {Object.keys(DataContainer.mApplicationData).length !== 0 ? DataContainer.sectionKey(DisclaimerTexts.MAIN_DISCLAIMER, DisclaimerTexts.DISCLAIMER_TITLE) : DisclaimerTexts.MARKETS_DISCLAIMER_TITLE}
        </Typography>
      </div>
      <div
        className={classNames({
          "text-xs text-secondary w-full pt-3": !isInfoModal,
          "text-[13px] text-black px-6": isInfoModal,
          "lg:text-left text-center": positionOfTitle === "left" && !isInfoModal,
          "text-left": positionOfTitle === "left" && isInfoModal,
          "text-right": positionOfContent === "right",
          "text-center": positionOfContent === "center",
          "md:w-2/4": !isSummary && !isInfoModal,
        })}
      >
        {Object.keys(DataContainer.mApplicationData).length !== 0 ? DataContainer.sectionKey(DisclaimerTexts.MAIN_DISCLAIMER, DisclaimerTexts.DISCLAIMER_TEXT) : DisclaimerTexts.MARKETS_DISCLAIMER_TEXT}
      </div>
      {isInfoModal && <hr className="border-t border-[rgb(233,233,233)] w-full"></hr>}
      <div
        className={classNames("flex w-full pt-1 flex-wrap", {
          "lg:justify-start justify-center": positionOfLinks === "left",
          "justify-end": positionOfLinks === "right",
          "justify-center": positionOfLinks === "center",
          "md:w-2/4": !isSummary && !isInfoModal,
          "gap-3 cursor-pointer px-6": isInfoModal
        })}
      >
        {links.map((item: Links) => (
          <Button
            key={item.title}
            onClickEvent={() => window.open(item.link)}
            variant={isInfoModal ? VarianButtonEnum.SECONDARY : VarianButtonEnum.TEXTBUTTON}
            customClassNames={isInfoModal ? "cursor-pointer !w-full md:!w-auto border rounded-md border-black" : ""}
            customClassNamesSpan={isInfoModal ? "cursor-pointer text-black hover:no-underline !font-extrabold text-2xs" : ""}
            text={item.title}
            disclaimer={true}
          />
        ))}
      </div>
    </div>
  );
};
